import Tooltip from "@components/Tooltips/Tooltip";
import styled from "@emotion/styled";
import {mq} from "@styles/helpers";
import {Devices} from "@styles/tokens";


export const TopNav = styled.div`
    display:flex;
    justify-content: end;
    height: 32px;
    gap:8px;
    margin-bottom: 20px;

    span:nth-of-type(1){
        margin-right: auto;
    }

    h2{
        font-size: 22px;
        font-weight: 500;
        margin-right: auto;
    }
`;

export const NavButton = styled.div<{disable?:boolean}>`
    background: ${props => props.theme.colors.placeholderColor};
    height:100%;
    aspect-ratio: 1 / 1;
    border-radius: 3px;
    display:flex;
    align-items: center;
    justify-content: center;
    padding:5px;
    cursor:pointer;
    transition: all 0.1s ease-in-out;
    pointer-events: ${props => props.disable?"none":"unset"};
    opacity: ${props => props.disable?"0.7":"1"};

    svg{
        path{
            fill:#fff;
        }
    }

    :hover{
        opacity: 0.8;
    }
`;



export const TableList = styled.table`
    width:100%;
    border-collapse: collapse;
    margin-bottom: 100px;
`;


export const THead = styled.thead`
    th{
        padding:4px 8px;
        color:${props => props.theme.colors.placeholderColor};
        text-align: left;

        :nth-of-type(1){
            width:40px;
        }
        :nth-of-type(2){
            width:40px;
        }

        :nth-of-type(3){
            width:50%;
        }
        :nth-of-type(4){
            width:20%;
        }

        :nth-of-type(5){
            width:20%;
        }

        :nth-of-type(6){
            width:80px;
        }
    }
`;

export const SortHeader = styled.div<{sort?:boolean, active?:boolean}>`
    display:inline-flex;
    align-items:center;
    gap:10px;
    cursor: pointer;
    font-size: 20px;
    font-weight: 500;

    svg{
        width:15px;
        transform: ${props => props.sort?"rotate(180deg)":"unset"};
        path{
            fill: ${props => props.active?props.theme.colors.placeholderColor:"rgb(192, 192, 192)"};
        }
    }
`;

export const TBody = styled.tbody<{disableHover?:boolean}>`
    
    td{
        padding:4px 8px;
        border-top: 1px solid rgba(137, 137, 137, 0.50);
        position: relative;
        font-size: 16px;

        :nth-last-of-type(2), 
        :nth-last-of-type(3), 
        :nth-last-of-type(4), 
        :nth-last-of-type(5){
            cursor: ${props => props.disableHover?"unset":"pointer"};
        }
    }

    tr{
        transition: all 0.1s ease-in-out;
        
        :hover{
            background:${props => props.disableHover?"unset":"rgba(42, 132, 142, 0.171)"};
        }
    }
`;


export const DropSelect = styled.div`
    position: relative;
    height:100%;
    cursor: pointer;
    font-size: 16px;
    border-radius: 4px;
    background:#fff;
    border: 1px solid #DCDCDC;
    padding:0 10px;   
    min-width: 225px;
    z-index: 4;

    > div:nth-child(1){
        width:100%;
        height:100%;
        display:flex;
        align-items: center;
    }

    svg{
        height:16px;
        position: absolute;
        right:10px;
        top:50%;
        transform: translateY(-50%);
        pointer-events: none;
    }
`;

export const DropDown = styled.div<{active:boolean}>`
    display: ${props => props.active?"block":"none"};
    position: absolute;
    top:100%;
    right:0;
    min-width: 100%;
`;

export const DropContent = styled.div`
    background:#fff;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.25);
    display:flex;
    flex-direction: column;
    padding:2px;
    border-radius: 4px;
    margin-top: 6px;

`;

export const DropSpan = styled.span<{sel:boolean}>`
    
    border-radius: 4px;
    width:100%;
    padding: 5px 8px;
    font-weight: ${props => props.sel?"600":"400"};
    :hover{
        color:#fff;
        background:rgba(42,132,142,0.72);
    }
`;


export const CheckItem = styled.div<{checked:boolean}>`
    width:18px;
    height:18px;
    border-radius: 4px;
    border:1px solid rgba(42,132,142,0.52);
    background:${props => props.checked?"rgba(42,132,142,0.72)":"rgb(255, 255, 255)"};
    content: " ";
    cursor: pointer;
`;


export const StudentImage = styled.div`
    position: relative;
    height:40px;
    aspect-ratio: 1 / 1;
    border-radius: 4px;
    box-shadow: 0 0 2px rgba(0,0,0,0.25);
    overflow: hidden;
`;

export const StudentOptions = styled.div`
    height:40px;
    display:flex;
    align-items: center;
    justify-content: end;
    gap:10px;
  
  div {
    display:flex;
    align-items: center;
    justify-content: end;
  }
`;

export const TooltipStudentOptions = styled(Tooltip)`
    height:100%;
    width:40px;
`;


export const OptionButton = styled.button<{active?:boolean}>`
    background:transparent;
    height:100%;
    aspect-ratio: 1 /1 ;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: ${props => props.active?"1":"0.5"};
    transition: all 0.2s ease-in-out;
    position: relative;

    svg{
        height:65%;
    }
`;

export const AlertOption = styled.button<{active?:boolean}>`
    background:transparent;
    height:100%;
    aspect-ratio: 1 /1 ;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease-in-out;
    position: relative;

    svg{
        height:65%;
        path{
            fill:${props => props.active?"#2A848E":"#909090"};
        }
    }
`;

export const Popup = styled.div<{show?:boolean}>`
    position: fixed;
    background:#ffffff45;
    top:0;
    left:0;
    width:100%;
    height:100vh;
    z-index:1200;
    display:${props => props.show?"flex":"none"};
    align-items: center;
    justify-content: center;
`;

export const PopupBox = styled.div`
    position: relative;
    max-width:320px;
    width:100%;
    min-height:150px;
    background:#fff;
    border-radius: 5px;
    padding:50px 20px 20px 20px;
    overflow:hidden;
    box-shadow: 0 0 3px 1px rgba(0,0,0,0.3);

    p{
      font-size: 16px;
    }

    div:nth-of-type(2){
      display:flex;
      width:100%;
      gap:20px;
      margin-top: 30px;
      
      button{
        width:100%;
        background:#2A848E;
        color:#fff;
        border-radius:5px;
        font-size: 16px;
        font-weight: 500;
        padding:8px 0;
      }
    }
    
`;

export const BoxTop = styled.div`
  position: absolute;
  top:0;
  left:0;
  width:100%;
  height:34px;
  background:#2A848E;
  display: flex;
  align-items: center;  
    
  span {
    color: #fff;
    margin-left: 10px;
    font-size: 16px;
    font-weight: 600;
  }
  
  button{
    width:16px;
    color:#fff;
    margin-left: auto;
    margin-right: 10px;
    margin-top: 4px;
    path{
      fill:#fff;
    }
  }
`;


export const EmptyScreen = styled.div`
    width:100%;
    height: calc(80vh - var(--header-height) - var(--regi-nav-height));
    display:flex;
    justify-content: center;
    align-items: center;
    padding:30px;
`;